import React from 'react';
import { useResponseContext } from '../../../../../ResponseContext';
import { constructAdditionalElementKey } from 'js/engines/CapabilitiesAssessment/utils';
import Element from '../../Element';

function AdditionalElement({ page, element, capabilityElement }) {
  const { questionMap } = useResponseContext();
  const questionKey = constructAdditionalElementKey(
    page,
    capabilityElement,
    element
  );

  const question = questionMap[questionKey];

  if (!question) {
    return null;
  }

  // return null;

  return <Element element={question} />;
}

export default AdditionalElement;
